import styled from 'styled-components';

export const InlineInputCardWrapper = styled.div`
  font-family: Inter, sans-serif;
  font-size: 1.4rem;
  color: rgb(149, 162, 174);
  background-color: white;
  border-radius: 1rem;
  padding: 1.2rem 1.5rem;

  &&.rich-text {
    padding: 0 !important;
  }

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  min-height: 6.2rem;

  &.error {
    border: 1px solid rgba(255, 0, 0, 0.27);
  }

  & > span {
    user-select: none;
    font-weight: 600;
  }
`;

export const InlineInputCardNameWrapper = styled.span`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 1rem;
`;

export const InputDescriptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  justify-content: center;
  align-items: center;

  &.offset {
    span {
      margin-right: 0.8rem;
    }
  }

  span {
    font-size: 1.1rem;
    font-family: 'JetBrains Mono', sans-serif;
    color: rgb(149, 162, 174);
    text-transform: uppercase;
  }
`;

export const StackedInputGroupWrapper = styled.div`
  display: flex;
  flex-direction: column;
  box-shadow: rgba(177, 217, 203, 0.18) 0px 10px 26px 0px;
  color: rgb(149, 162, 174);
  background-color: white;
  border-radius: 1rem;
  padding-bottom: 1rem;

  &&:empty {
    display: none;
  }
`;

export const InputGroupDivider = styled.div`
  height: 1px;
  width: 100%;
  background-color: rgba(149, 162, 174, 0.2);
  margin: 0.5rem 0;
`;
